import { Component, OnInit, Output, EventEmitter, Input, HostListener } from '@angular/core';
import * as d3 from 'd3';
declare var $: any;
@Component({
  selector: 'app-stackedcolumn-chart',
  templateUrl: './stackedcolumn-chart.component.html'
})
export class StackedcolumnChartComponent implements OnInit {
  @Input() GraphData: any;
  totalPage: number;
  currentPage: number = 1;
  maxValue: number;
  constructor() { }
  viewData = [];
  barnumber = 4;
  minPointLength;
  ngOnInit(): void {
  }
  ngAfterViewInit() {
    this.RenderStackedColumnCharts(Object.assign({}, this.GraphData));
  }
  RenderStackedColumnCharts(inputData) {
    let that = this;
    this.maxValue = 0;
    let scrollbar = false;
    let containerId = inputData.chartContainerName;
    let containerIdwithoutHash = containerId.split('#')[1];
    let divId = '#div_' + containerIdwithoutHash;
    d3.select(containerId).html("");
    d3.select(containerId).append("div").attr('id', 'div_' + containerIdwithoutHash);
    d3.select(divId).classed('stackedcolumn', true);
    let divWidth = d3.select(divId).node().offsetWidth;
    //this.viewData = inputData.chartData.slice((this.currentPage - 1) * this.barnumber, this.currentPage * this.barnumber);
    //document.getElementById(inputData.chartContainerName).innerHTML = '';
    //document.getElementById(inputData.chartContainerName).classList.add("stackedcolumn");
    var stackData = [];
    var stackDataDummy = [];
    var w = d3.select(containerId).node().offsetWidth; //document.getElementById(inputData.chartContainerName).offsetWidth;
    var h = 350;
    var margin = {
      top: 20,
      bottom: 80,
      left: 80,
      right: 10,
    };
    let legendWidth = divWidth - (margin.left + margin.right) - 18;
    d3.select(divId).style("max-height", h + "px").style("max-width", w + "px").style("overflow-x", "auto").style("overflow-y", "auto");
    //var rectHeight = 25;
    var rectWidth = 30;
    //var SVGheight = (rectHeight * heatMapData.yAxisCategories.length) + 100;
    var SVGWidth = (rectWidth * this.barnumber) + 140;
    // if (SVGWidth > w) {
    //     //w = SVGWidth;
    //     //scrollbar = true;
    // }
    //w = SVGWidth;
    var width = w - margin.left - margin.right;
    var height = h - margin.top - margin.bottom;
    //var colors = d3.schemePaired;//['#FF9A00', '#FFEBB6', '#FFC400', '#B4EDA0', '#FF4436'];
    //var colors = ['#7cb5ec', '#434348', '#90ed7d', '#f7a35c', '#8085e9', '#f15c80', '#e4d354', '#2b908f', '#f45b5b', '#91e8e1'];
    var colors = ['#A260B7', '#E370B3', '#46BDF0', '#98BB56', '#AA6544', '#6FD9DD', '#5589BB', '#68C083'];
    //var colors = ["#a75eba", "#e370b3", "#47bdef", "#a0c036", "#aa6544", "#6fd9dd", "#267db3", "#68c083", "#e891ff", "#ffb5e0", "#9de0fc", "#e1ff7d", "#fa8e5a", "#b3fafc", "#b3e0fc", "#a4fcbf", "#ecb4fa", "#fccfe9", "#cfeffc", "#f0ffbd"];
    //var stackData = inputData.chartData.map(d => { return { x: inputData.xAxisCategories[d.col], y: inputData.yAxisCategories[d.row], data: d.data } })
    //var stackData = inputData.chartData.map(d => { return { [inputData.yAxisCategories[d.row]]: d.data, x: inputData.xAxisCategories[d.col] } })    
    //this.maxValue = Math.max(...inputData.chartData.map(o => o.data), 0);
    //this.minPointLength = this.FindZeroValue(this.maxValue);
    inputData.xAxisCategories.forEach((d, i) => {
      var stackObj = {};
      inputData.chartData.filter(x => x.col == i).forEach(a => {
        var x = inputData.newKeys.indexOf(inputData.yAxisCategories[a.row]);
        if (x >= 0)
          stackObj[inputData.yAxisCategories[a.row]] = (a.data == 0 ? 5.99999 : a.data)
      });
      stackDataDummy.push(stackObj);
    });
    var stackDummy = d3.stack()
      .keys(inputData.newKeys)
      .order(d3.stackOrderNone)
      .offset(d3.stackOffsetNone);
    var stackedSeriesDummy = stackDummy(stackDataDummy);
    var maxDataY = d3.max(stackedSeriesDummy, function (d) {
      return d3.max(d, (d) => {
        return d[1];
      })
    });
    this.minPointLength = this.FindZeroValue(maxDataY);
    this.totalPage = Math.ceil(inputData.xAxisCategories.length / this.barnumber);
    inputData.xAxisCategories = inputData.xAxisCategories.slice((this.currentPage - 1) * this.barnumber, this.currentPage * this.barnumber);
    if (this.currentPage == 1) {
      inputData.chartData = inputData.chartData.filter(x => x.col < inputData.xAxisCategories.length);
    }
    else {
      var data = [];
      inputData.xAxisCategories.forEach((d, i) => {
        i = i + (this.currentPage - 1) * this.barnumber;
        data.push(inputData.chartData.filter(x => x.col == i));
      });
      inputData.chartData = Array.prototype.concat.apply([], data);
    }
    inputData.xAxisCategories.forEach((d, i) => {
      var stackObj = {};
      if (this.currentPage > 1) {
        i = i + (this.currentPage - 1) * this.barnumber;
      }
      inputData.chartData.filter(x => x.col == i).forEach(a => {
        var x = inputData.newKeys.indexOf(inputData.yAxisCategories[a.row]);
        if (x >= 0)
          stackObj[inputData.yAxisCategories[a.row]] = (a.data)
      });
      stackData.push(stackObj);
    });
    // Object.keys(stackData[0]).forEach((i) => { return this.maxValue += stackData[0][i] });
    // this.minPointLength = this.FindZeroValue(this.maxValue);
    var stack = d3.stack()
      .keys(inputData.newKeys)
      .order(d3.stackOrderReverse)
      .offset(d3.stackOffsetNone);
    //.offset(d3.stackOffsetExpand);

    var stackedSeries = stack(stackData);
    var x = d3.scaleBand()
      .domain(stackData.map(function (d, i) {
        return inputData.xAxisCategories[i];
      }))
      .rangeRound([0, width])
      //.rangeRound([0, rectWidth * this.barnumber])
      .padding(0.4);
    //console.log(d3.min(stackedSeries, function (d) {
    //    return d3.max(d, (d) => {
    //        return d[0];
    //    })
    //}));
    // let maxDataY = d3.max(stackedSeries, function (d) {
    //   return d3.max(d, (d) => {
    //     return d[1];
    //   })
    // });
    var yRange = d3.scaleLinear().range([height, 0]);
    var yScale = yRange.domain([0, maxDataY]);
    let yTicks = that.GenerateTicks(yRange, maxDataY);
    maxDataY = yTicks[yTicks.length - 1];
    var y = yRange.domain([0, maxDataY]);

    // var y = d3.scaleLinear()
    //   .domain([0, d3.max(stackedSeries, function (d) {
    //     return d3.max(d, (d) => {
    //       return d[1];
    //     })
    //   })])
    //   .range([height, 0]);

    var svg = d3.select(divId)
      //.append("div")
      //.classed("svg-container", true)
      .append('svg')
      .classed("resizableSVG", true)
      //.attr('width', w)
      //.attr('height', h)
      .attr('id', 'svg_' + containerIdwithoutHash)
      .attr('xmlns', "http://www.w3.org/2000/svg")
      .attr('preserveAspectRatio', 'xMidYMid meet')
      .style('overflow', 'visible')
    if (!scrollbar) {
      d3.select('#svg_' + containerIdwithoutHash)
        //.attr('viewBox', "0 0 " + w + " " + h + "");
        .attr('width', width)
        .attr('height', h);
    }
    else {
      d3.select('#svg_' + containerIdwithoutHash)
        .attr('width', w)
        .attr('height', 300);
      //.attr('height', h)
    }
    svg.append("defs").append("clipPath")
      .attr("id", containerIdwithoutHash + "_clip")
      .append("rect")
      .attr("width", width)
      .attr("height", height);
    //.classed("svg-content", true);
    svg.append("text")
      .attr("transform", "rotate(-90)")
      .attr("y", 10)
      .attr("x", 0 - (height / 2) - 20)
      .attr("dy", "1em")
      .style("text-anchor", "middle")
      .attr('fill', '#015b63')
      .style('font-size', "12px")
      .style('font-weight', 'bold')
      .attr("font-family", "Graphik Regular")
      .text(inputData.valueType == "TicketCount" ? "TicketCount" : "TicketAge (In days)");
    var chart = svg.append('g')
      .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
    var xAxis = chart.append('g')
      .classed('xaxis', true)
      .attr("transform", "translate(0," + height + ")")
      .call(d3.axisBottom(x));
    xAxis.selectAll('line')
      .attr('stroke', '#e6e6e6');
    xAxis
      .select('.domain')
      .style('opacity', 0);
    xAxis.selectAll('text')
      .style('text-anchor', 'middle')
      .attr('fill', '#000')
      .style('font-size', '10px')
      //.style('font-family', '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif')
      .attr("font-family", "Graphik Regular")
      .attr("font-size", "10px")
      .style('white-space', 'nowrap')
      .style('cursor', 'default')
      .attr('y', '10')
      //.attr('dy', '0.71em')
      .attr('x', '0')
      //.attr('transform', d => 'rotate(-45)')
      .text(d => {
        if (d.length > 10) {
          d = d.substring(0, 7) + '...';
        }
        return d;
      })
      .append('title')
      //.text(d => d.length > 7 ? d : null);
      .text(d => d);
    // xAxis.selectAll('line')
    //   .attr('stroke', '#e6e6e6')

    var yAxis = chart
      .append('g')
      .classed('yaxis', true)
      .call(d3.axisLeft(y)
        .tickSize(-width, 0, 0)
        .tickPadding(10)
        .tickValues(that.GenerateTicks(yRange, maxDataY))
        .tickFormat(d => {
          return (d > 1 || d == 0) ? `${d3.format("~s")(d)}` : d.toFixed(1);
        }))
    yAxis
      .selectAll('line')
      .attr('stroke', '#e6e6e6')
    yAxis
      .select('.domain')
      .style('opacity', 0)
    yAxis
      .selectAll('text')
      .style('text-anchor', 'end')
      .attr('fill', '#000')
      // .style('font-size', '11px')
      // .style('font-family', '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif')
      .attr("font-family", "Graphik Regular")
      .attr("font-size", "10px")
      .style('white-space', 'nowrap')
      .style('cursor', 'default')
    var layersArea = chart
      .append('g')
    //.classed('stackChart',true);
    var currentPathIteration = 0;
    var currentIdIteration = 0;
    var currentTextIteration = 0;
    var currentIteration = 0;
    var totalIteration = inputData.xAxisCategories.length * inputData.newKeys.length;
    // var limitRoundCorner = totalIteration - inputData.yAxisCategories.length;
    var rx = rectWidth / 2;
    var ry = rectWidth / 2;
    var layers = layersArea.selectAll('g')
      .data(stackedSeries)
      .enter()
      .append('g')
      .attr("clip-path", "url(#" + containerIdwithoutHash + "_clip)")
    var rects = layers.append('g')
      //.attr('id', (d, i) => 'RectG_' + i)
      //.attr('class', 'stack')
      .style('fill', (d, i) => {
        i = inputData.yAxisCategories.indexOf(d.key); //inputData.newKeys[i]);
        if (i >= 0) {
          return colors[i % colors.length];
        }
      })
      .selectAll('rect')
      .data((d, i) => d)
      .enter()
      .append("path")
      .attr("d",
        function (d, i) {
          currentPathIteration++;
          var s = 0;
          if (currentPathIteration <= inputData.xAxisCategories.length) {
            //s = 8;
            // return `M${x(inputData.xAxisCategories[i]) + x.bandwidth() / 2 - (rectWidth / 2)},${y(d[1]) + ry}
            // a${rx},${ry} 0 0 1 ${rx},${-ry}
            // h${rectWidth - 2 * rx}
            // a${rx},${ry} 0 0 1 ${rx},${ry}	
            // v${height - y(d[1]) - ry}		      
            // h${-(rectWidth)}Z`;
            return that.bar(
              x(inputData.xAxisCategories[i]) + (x.bandwidth() / 2) - (rectWidth / 2),
              y(0),
              rectWidth,
              y(d[1]), s, undefined);
          }
          else {
            return that.bar(
              x(inputData.xAxisCategories[i]) + (x.bandwidth() / 2) - (rectWidth / 2),
              y(0),
              rectWidth,
              y(d[1]), s, undefined);
          }
        })
      .attr('id', (d, i) => {
        currentIdIteration++;
        return 'rectPath_' + containerIdwithoutHash + '_' + currentIdIteration;
      });

    // svg.append("g").attr('transform', 'translate(' + margin.left + ',' + margin.top + ')').attr('class', 'textLabels')
    //     .selectAll('g')
    //     .data(stackedSeries)
    //     .enter()
    layers.append('g')
      .selectAll('rect')
      .data((d, i) => d)
      .enter()
      .append("text")
      .attr("text-anchor", "middle")
      .attr("y", d => y(d[1]) - (y(d[1]) - y(d[0])) / 2 + 2)
      .attr("x", (d, i) => x(inputData.xAxisCategories[i]) + (x.bandwidth() / 2) - (rectWidth / 2) + 14)
      .attr("font-size", "8px")
      .style("fill", "black")
      .attr("font-family", "Graphik SemiBold")
      .attr("id", (d, i) => {
        currentTextIteration++;
        return 'text_' + containerIdwithoutHash + '_' + currentTextIteration;
      })
      .text((d, i) => {
        currentIteration++;
        //console.log(d3.format("~s")(d[1] - d[0]))
        //return d3.format("~s")(d[1] - d[0]);
        if (currentIteration < (totalIteration - inputData.xAxisCategories.length)) {
          if (d3.select('#rectPath_' + containerIdwithoutHash + '_' + currentIteration).node().getBBox().height - d3.select('#rectPath_' + containerIdwithoutHash + '_' + (currentIteration + inputData.xAxisCategories.length)).node().getBBox().height > 9)
            return that.CleanNumber(d[1] - d[0]);
        }
        else {
          if (d3.select('#rectPath_' + containerIdwithoutHash + '_' + currentIteration).node().getBBox().height > 9)
            return that.CleanNumber(d[1] - d[0]);
        }
      });
    // .append('rect')
    // //.attr('data-name', (d, i) => inputData.yAxisCategories[i])
    // //.attr('data-value', (d, i) => {
    // //    //console.log(d.data);
    // //    return d.data[inputData.yAxisCategories[d["i"]]]
    // //})
    // .attr('height', (d, i) => {
    //     return y(d[0]) - y(d[1]);
    // })
    // .attr('y', (d) => {
    //     return y(d[1]);
    // })
    // .attr('x', (d, i) => {
    //     return x(inputData.xAxisCategories[i]) + (x.bandwidth() / 2) - (rectWidth / 2);
    // })
    // .attr('stroke', 'white')
    // .attr('stroke-width', 1)
    // .attr('width', rectWidth)

    ////d3.select('#' + inputData.chartContainerName).select('.stackChart').selectAll('rect')
    ////d3.selectAll('.stackedcolumn').selectAll('rect')
    //console.log(d3.select('#' + inputData.chartContainerName).selectAll('rect').nodes())
    ////$('.stackedcolumn').find('rect')
    //d3.selectAll('.stackedcolumn').selectAll('rect')
    rects.on('mouseover', function (d, i) {
      //console.log(d);
      //console.log(d3.select(this.parentNode).datum().key)
      d3.select(this).style('cursor', 'pointer');
      var tooltip = svg
        .append("g")
        .style("cursor", "pointer")
        .attr("class", "tooltip")
        .style("opacity", 1)
      tooltip.append("rect")
        .attr("width", 90)
        .attr('height', 40)
        .style('fill', '#FFFFFF')
        .style('pointer-events', 'none')
        .style('stroke', d3.select(this).style('fill'))
        .style('stroke-width', 2)
        .style('fill-opacity', 0.8);
      var textSvg = tooltip.append("text")
        .attr('x', 7)
        .attr('y', 15)
        .style('pointer-events', 'none')
        .style('fill', '#333333')
        .style('font-size', '12px')
        .style('color', '#333333');
      textSvg.append("tspan")
        .style('font-size', '11px')
        .style('pointer-events', 'none')
        .attr("font-family", "Graphik Regular")
        .style('font-weight', 'bold')
        .text(inputData.xAxisCategories[i])
      textSvg.append("tspan")
        .attr('x', 7)
        .attr('dy', 15)
        .style('pointer-events', 'none')
        .style('fill', d3.select(this).style('fill'))
        .html('&#x25cf') //&#9679; //&bull;
      textSvg.append("tspan")
        .attr('dx', 0)
        .style('pointer-events', 'none')
        .style('font-size', '11px')
        .attr("font-family", "Graphik Regular")
        .style('font-weight', 'bold')
        .text(d3.select(this.parentNode).datum().key + ': ')
        .style('font-weight', 'bold')
      textSvg.append("tspan")
        .attr('dx', 0)
        .style('pointer-events', 'none')
        .attr("font-family", "Graphik Regular")
        .style('font-weight', 'bold')
        .text(d3.format(',')(parseInt(d.data[d3.select(this.parentNode).datum().key] == that.minPointLength ? 0 : d.data[d3.select(this.parentNode).datum().key])));
    })
      .on("mousemove", function (d) {
        d3.select(this).style('opacity', 1)
        d3.select(this).style('cursor', 'pointer');
        var mousePosition = d3.mouse(this);
        var x = mousePosition[0];// + width / 2;
        var y = mousePosition[1];// + height / 2;
        var text = d3.select(this.closest('svg')).select('.tooltip text');
        //svg.selectAll('.tooltip text tspan').nodes().forEach(element => {
        //    console.log(element.getBBox().width);
        //})
        var bbox = text.node().getBBox();
        d3.select(this.closest('svg'))
          .select('.tooltip rect')
          .attr("width", bbox.width + 15)
        if (x - bbox.width / 2 < 0) {
          x = bbox.width / 2;
        }
        else if (width - x - bbox.width / 2 < 0) {
          x = width - bbox.width / 2;
        }
        if (y - bbox.height / 2 < 0) {
          y = bbox.height * 2;
        }
        else if (height - y - bbox.height / 2 < 0) {
          y = height - bbox.height / 2;
        }
        d3.select(this.closest('svg'))
          .select('.tooltip')
          .style("opacity", 1)
          .attr('transform', `translate(${x + 10}, ${y - 20})`);
      })
      .on("mouseout", function (d) {
        d3.select(this.closest('svg'))
          .select('.tooltip').style('display', 'none');
        d3.select(this.closest('svg'))
          .select(".tooltip").remove();
        d3.select(this)//.selectAll('path')
          .style("opacity", 1);
      })
    //d3.select('#' + inputData.chartContainerName).selectAll('rect')        
    let legendsSVG;
    if (scrollbar) {
      d3.select(containerId).append('div').attr('id', 'divLegend_' + containerIdwithoutHash).attr('width', divWidth).append('svg').attr('id', 'svgLegend_' + containerIdwithoutHash).attr('width', divWidth).attr('height', 80);
      legendsSVG = d3.select('#svgLegend_' + containerIdwithoutHash).append('g')
        .attr('transform', "translate(" + (margin.left - margin.right - 20) + "," + 20 + ")")
        .attr('width', divWidth)
        .attr('height', 80)
        .style('overflow', 'auto');
    }
    else {
      legendsSVG = svg.append('g')
        .attr('transform', "translate(" + (margin.left - margin.right - 20) + "," + (height + margin.top + $(inputData.chartContainerName).find('.xaxis')[0].getBoundingClientRect().height + 20) + ")")
        .attr('width', divWidth)
        .attr('height', margin.bottom - ($(inputData.chartContainerName).find('.xaxis')[0].getBoundingClientRect().height + 5))
        .style('overflow', 'auto');
    }
    // legendsSVG.append('rect')
    //     .attr('fill', 'none')
    //     .attr('rx', "0")
    //     .attr('ry', "0")
    //     .attr('x', "0")
    //     .attr('y', "0")
    //     .attr('width', divWidth)
    //     .attr('height', 80);
    var legendGroups = legendsSVG.append('g').attr('id', containerIdwithoutHash + '_legendGroup')//.style('transform', 'translate(50%, 50%)')//.attr('x', "50%").attr('y', "50%");
    var legendGroup = legendGroups.append('g').selectAll('g')
      .data(inputData.yAxisCategories)
      .enter()
      .append('g')
      .on('click', (d, i) => {
        //console.log('clicked' + i);
        inputData.xAxisCategories = this.GraphData.xAxisCategories;
        inputData.chartData = this.GraphData.chartData;
        if ($(legendGroup.nodes()[i]).find('rect').attr('fill') != '#cccccc') {
          inputData.newKeys.splice(inputData.newKeys.indexOf(d), 1);
          //$(legendGroup.nodes()[i]).find('rect').attr('fill','#cccccc');
        }
        else {
          inputData.newKeys.splice(inputData.yAxisCategories.indexOf(d), 0, d);
        }
        var x = parseInt(legendGroup.nodes().filter(d => $(d).css('display') != 'none')[0].id);
        inputData.currentGroup = x;
        that.RenderStackedColumnCharts(inputData);
      });
    legendGroup.append('text')
      .style("color", "#015b63")
      .style("font-size", "12px")
      .style("font-weight", "bold")
      .style("cursor", "pointer")
      .style("fill", "#015b63")
      .attr("text-anchor", "start")
      .attr("x", "21")
      .attr("y", "15")
      .attr("font-family", "Graphik Regular")
      .append('tspan')
      .text((d, i) => {
        return (d.length > 20 ? d.substring(0, 20) + "..." : d);
      })
      .append('title')
      .text(d => d)
      .on('mouseover', (d, i) => {
        $(legendGroup.selectAll('text').nodes()[i]).css('fill', 'black');
      })
      .on('mouseout', (d, i) => {
        $(legendGroup.selectAll('text').nodes()[i]).css('fill', "#015b63");
      });
    legendGroup.append('rect')
      .attr("x", "2")
      .attr("y", "4")
      .attr("width", "12")
      .attr("height", "12")
      .attr('fill', (d, i) => {
        return colors[i % colors.length];
      })
      .attr("rx", "6")
      .attr("ry", "6");
    var symbol = d3.symbol();
    var legendScroll = legendGroups.append('g')
      .attr('transform', "translate(" + (d3.select(containerId).node().offsetWidth - margin.left - margin.right + (2 * margin.right)) + "," + 5 + ")")
      .attr('class', 'legendscroll');
    var LegentScrollText = legendScroll.append('text')
    legendScroll.append("path")
      .attr("d", symbol.type(d3.symbolTriangle))
      .attr('class', 'uppertriangle')
      .attr('fill', '#cccccc')
      .style('cursor', 'default')
      .on('click', () => {
        var i = parseInt(legendGroup.nodes().filter(d => $(d).css('display') != 'none')[0].id);
        var totalGrps = parseInt(legendScroll.attr('total'));
        if (i > 1) {
          legendGroup.nodes().filter(d => d.getAttribute('id') == i)
            .forEach((d, i) => d.setAttribute('display', 'none'));
          var lblGrps = legendGroup.nodes().filter(d => d.getAttribute('id') == (i - 1));
          that.scrollLegends(lblGrps, width, legendScroll, false, LegentScrollText);
          legendScroll.select('text')
            .text((i - 1) + "/" + totalGrps);
        }
        if (i != 1 && (i - 1) < totalGrps) {
          legendScroll.select('.lowertriangle').node().setAttribute('fill', '#003399');
          $(legendScroll.select('.lowertriangle').node()).css('cursor', 'pointer');
        }
        else {
          legendScroll.select('.lowertriangle').node().setAttribute('fill', '#cccccc');
          $(legendScroll.select('.lowertriangle').node()).css('cursor', 'default');
        }
        if ((i - 1) <= 1) {
          //legendScroll.select('.lowertriangle').node().setAttribute('fill', '#003399');
          //$(legendScroll.select('.lowertriangle').node()).css('cursor', 'pointer');
          legendScroll.select('.uppertriangle').node().setAttribute('fill', '#cccccc');
          $(legendScroll.select('.uppertriangle').node()).css('cursor', 'default');
        }
        else {
          legendScroll.select('.uppertriangle').node().setAttribute('fill', '#003399');
          $(legendScroll.select('.uppertriangle').node()).css('cursor', 'pointer');
        }
      });
    //var dummyLegendGroup = legendGroup;
    legendScroll.append("path")
      .attr("d", symbol.type(d3.symbolTriangle))
      .attr('transform', "translate(0" + "," + 30 + ") rotate(180)")
      .attr('class', 'lowertriangle')
      .style('cursor', 'pointer')
      .attr('fill', '#003399')
      .on('click', () => {
        that.clickScrollDown(legendGroup.nodes(), width, legendScroll, false, LegentScrollText, 1);
      });
    var grpNodes = legendGroup.nodes();
    this.scrollLegends(grpNodes, width, legendScroll, true, LegentScrollText);
    if (inputData.currentGroup != 1) {
      //grpNodes = grpNodes.filter(d => d.getAttribute('id') == inputData.currentGroup);
      //scrollLegends(grpNodes, width, legendScroll, true, LegentScrollText);
      this.clickScrollDown(grpNodes, width, legendScroll, false, LegentScrollText, (inputData.currentGroup - 1));
    }
    else {
      grpNodes.filter(d => d.getAttribute('id') != 1)
        .forEach((d, i) => d.setAttribute('display', 'none'));
    }
    inputData.yAxisCategories.forEach((d, i) => {
      if (!inputData.newKeys.includes(d))
        $(legendGroup.nodes()[i]).find('rect').attr('fill', '#cccccc');
    });
    //d3.select('#svg_' + inputData.chartContainerName)
    //    .select('.legendscroll')
    //    .select('text')
    //    .text("1/" + totalLines)
    //    .attr('fill', 'white');        
    //Pagination
    if (this.totalPage > 1) {
      svg.append("path")
        .attr("d", "M3.875,3.095,6.8.163a.551.551,0,0,1,.782,0,.558.558,0,0,1,0,.784L4.267,4.269a.553.553,0,0,1-.763.016L.161.949A.554.554,0,0,1,.943.165Z")
        .attr('transform', "translate(" + margin.left + ", " + (h - margin.bottom + 9) + ") rotate(90)")     //19 (Because tickpadding=8 + margin from insertLineBreak=10 + 1(MagicNumber))
        .attr('class', 'leftTriangle')
        .attr('fill', '#000')
        .attr('stroke', '#000')
        .attr('stroke-width', 2)
        .attr("opacity", 0.7)
        .attr('cursor', 'pointer')
        .on('click', function (d) {
          if (that.currentPage != 1) {
            that.currentPage--;
            that.prevPage(parseInt(legendGroup.nodes().filter(d => $(d).css('display') != 'none')[0].id));
          }
        })
      svg.append("path")
        .attr("d", "M3.875,1.335,6.8,4.267a.551.551,0,0,0,.782,0,.558.558,0,0,0,0-.784L4.267.161A.553.553,0,0,0,3.5.145L.161,3.481a.554.554,0,0,0,.782.784Z")
        .attr('transform', "translate(" + (w - margin.right - 1) + ", " + (h - margin.bottom + 9) + ") rotate(90)")
        .attr('class', 'rightTriangle')
        .attr('fill', '#000')
        .attr('stroke', '#000')
        .attr('stroke-width', 2)
        .attr("opacity", 0.7)
        .style('cursor', 'pointer')
        .on('click', function (d) {
          if (that.currentPage < that.totalPage) {
            that.currentPage++;
            that.nextPage(parseInt(legendGroup.nodes().filter(d => $(d).css('display') != 'none')[0].id));
          }
        })

      if (that.currentPage == 1) {
        svg.select(".leftTriangle").attr('fill', '#cccccc').attr('stroke', '#cccccc').attr('stroke-width', 2).attr("opacity", 0.7).style('cursor', 'default');
      }
      if (that.currentPage == that.totalPage) {
        svg.select(".rightTriangle").attr('fill', '#cccccc').attr('stroke', '#cccccc').attr('stroke-width', 2).attr("opacity", 0.7).style('cursor', 'default');
      }
    }
  }
  clickScrollDown(legendGroupNodes, width, legendScroll, isUpdateId, LegentScrollText, increment) {
    var i = parseInt(legendGroupNodes.filter(d => $(d).css('display') != 'none')[0].id);
    var totalGrps = parseInt(legendScroll.attr('total'));
    if (totalGrps > i) {
      legendGroupNodes.filter(d => d.getAttribute('id') != (i + increment))
        .forEach((d, i) => d.setAttribute('display', 'none'));
      legendGroupNodes.filter(d => d.getAttribute('id') == (i + increment))
        .forEach((d, i) => d.setAttribute('display', 'block'));
      var lblGrps = legendGroupNodes.filter(d => d.getAttribute('id') == (i + increment));
      this.scrollLegends(lblGrps, width, legendScroll, isUpdateId, LegentScrollText);
      legendScroll.select('text')
        .text((i + increment) + "/" + totalGrps);
      legendScroll.select('.uppertriangle').node().setAttribute('fill', '#003399');
      $(legendScroll.select('.uppertriangle').node()).css('cursor', 'pointer');
    }
    if ((i + increment) >= totalGrps) {
      //legendScroll.select('.uppertriangle').node().setAttribute('fill', '#003399');
      //$(legendScroll.select('.uppertriangle').node()).css('cursor', 'pointer');
      legendScroll.select('.lowertriangle').node().setAttribute('fill', '#cccccc');
      $(legendScroll.select('.lowertriangle').node()).css('cursor', 'default');
    }
    else {
      legendScroll.select('.lowertriangle').node().setAttribute('fill', '#003399');
      $(legendScroll.select('.lowertriangle').node()).css('cursor', 'pointer');
    }
  }

  scrollLegends(legendGroupNodes, width, legendScroll, isUpdateId, LegentScrollText) {
    var labels = legendGroupNodes//.nodes()//.selectAll('text');
    var textWidth = 0;
    var textHeight = 0;
    var space = 15;
    var totalLines = 1;
    var groupNumber = 1;
    var startPosition = 0;
    var totalWidth = 0;
    labels.forEach(function (d, i) { totalWidth += (d.getBBox().width + space) });
    labels.forEach(function (d, i) {
      //var x = labels.map(function (d, i) { return (d.getBBox().width + space) });
      //var totalWidth = x[x.length - 1];      
      if (totalLines == 1 && totalWidth <= width && textWidth == 0) {
        startPosition = (width / 2) - (totalWidth / 2);
      }
      if ((textWidth + d.getBBox().width) <= width) {
        if (startPosition == 0) {
          labels[i].setAttribute('transform', 'translate(' + textWidth + ',' + textHeight + ')');
        }
        else {
          labels[i].setAttribute('transform', 'translate(' + startPosition + ',' + 0 + ')');
          textWidth = startPosition;
          startPosition = 0;
        }
        labels[i].setAttribute('display', 'block')
        if (isUpdateId)
          labels[i].setAttribute('id', groupNumber);
      }
      else {
        totalLines += 1;
        textWidth = 0;
        textHeight += 22;
        labels[i].setAttribute('transform', 'translate(' + textWidth + ',' + textHeight + ')');
        labels[i].setAttribute('display', 'block')
        if (totalLines > 2 && totalLines % 2 != 0)
          groupNumber += 1;
        if (isUpdateId)
          labels[i].setAttribute('id', groupNumber);
      }
      textWidth += d.getBBox().width;
      textWidth += space;
    });
    let totalPageText = "1/" + Math.ceil(totalLines / 2);
    let x = totalPageText.length * 2;
    LegentScrollText
      .text(totalPageText)
      .attr('fill', 'rgb(1, 91, 99)')
      .attr('transform', "translate(-" + x + "," + 20 + ")")
      .style('font-size', '10px');
    if (isUpdateId)
      legendScroll.attr('total', Math.ceil(totalLines / 2));
    if (Math.ceil(totalLines / 2) == 1) {
      legendScroll.select('.lowertriangle').node().setAttribute('fill', '#cccccc');
      $(legendScroll.select('.lowertriangle').node()).css('cursor', 'default');
    }
  }

  /*generic way */
  nextPage(currentGroup) {
    //this.viewData = this.GraphData.chartData.slice((this.currentPage - 1) * this.barnumber, this.currentPage * this.barnumber);
    var inputObj = Object.assign({}, this.GraphData);
    inputObj.currentGroup = currentGroup;
    this.RenderStackedColumnCharts(inputObj);
  }

  prevPage(currentGroup) {
    //this.viewData = this.GraphData.chartData.slice((this.currentPage - 1) * this.barnumber, this.currentPage * this.barnumber);
    var inputObj = Object.assign({}, this.GraphData);
    inputObj.currentGroup = currentGroup;
    this.RenderStackedColumnCharts(inputObj);
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.RenderStackedColumnCharts(Object.assign({}, this.GraphData));
  }
  bar(x, y, w, y1, r, f) {
    // Flag for sweep:
    if (f == undefined) f = 1;
    // x coordinates of top of arcs
    var x0 = x + r;
    var x1 = x + w - r;
    // y coordinates of bottom of arcs
    var y0 = y1 + r;
    // just for convenience (slightly different than above):
    var l = "L", a = "A";

    var parts = ["M", x, y, l, x, y0, a, r, r, 0, 0, f, x0, y1, l, x1, y1, a, r, r, 0, 0, f, x + w, y0, l, x + w, y, "Z"];
    return parts.join(" ");
  }
  FindZeroValue(maxValue) {
    if (maxValue > 0 && maxValue < 20)
      return 0.39;
    else if (maxValue > 20 && maxValue < 50)
      return 0.59;
    else if (maxValue > 50 && maxValue < 100)
      return 2.99;
    else if (maxValue > 100 && maxValue < 1000)
      return 4.99;
    else if (maxValue > 1000)
      return 5.99;
  }
  isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }
  CleanNumber(str) {
    str = str.toFixed(2);
    if (str == this.minPointLength) {
      str = 0;
    }
    else {
      if (str >= 1)
        str = d3.format("~s")(str);
      else
        str = str;
    }
    if (!this.isNumeric(str)) {
      let lastLetter = str.substring(str.length - 1);
      str = str.substring(0, str.length - 1);
      if (str.indexOf('.'))
        str = parseFloat(str).toFixed(1).toString() + lastLetter;
    }
    return str;
  }
  GenerateTicks(axisRange, maxData) {
    let tickArray = axisRange.ticks(4);
    if (tickArray[tickArray.length - 1] < maxData) {
      let diff = (tickArray[tickArray.length - 1]) - (tickArray[tickArray.length - 2]); // Add the difference to create new tick
      tickArray.push(tickArray[tickArray.length - 1] + diff);
    }
    return tickArray;
  }
}
